import { useQuery } from "@tanstack/react-query";
import { fetchPatientTrend } from "../services/insights";

export function usePatientTrend(patientId?: string, hours: number = 168) {
  return useQuery({
    queryKey: ["patient-trend", patientId, hours],
    queryFn: async ({ signal }) => {
      if (!patientId) {
        throw new Error("patientId is required");
      }
      const response = await fetchPatientTrend(patientId, hours, signal);
      return response.trend;
    },
    enabled: Boolean(patientId),
    staleTime: 60 * 1000,
  });
}
